import React, { useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@rollbar/react';
import BrandNavBar from 'features/home/components/organisms/BrandNavBar';
import ScrollToTop from 'app/ScrollToTop';
import RightDrawer from 'shared/components/layout/RightDrawer/RightDrawer';
import RoutesWrapper from 'shared/router/RoutesWrapper';
import { ErrorPage } from 'features/ui/pages/ErrorPages';

const OnboardingWrapper = () => {
  const contentRef = useRef(null);
  const location = useLocation<any>();
  return (
    <>
      <BrandNavBar />
      <ScrollToTop contentRef={contentRef} />
      {/* @ts-ignore */}
      <ErrorBoundary key={location.pathname} fallbackUI={ErrorPage}>
        <RoutesWrapper>
          <RoutesWrapper.ContentWrapper id="content" ref={contentRef}>
            <Outlet />
          </RoutesWrapper.ContentWrapper>
          <RightDrawer />
        </RoutesWrapper>
      </ErrorBoundary>
    </>
  );
};

export default OnboardingWrapper;
